import { MissAnimBase } from "./AnimBase";
import { GoalieMissAnim } from "./Goalie";

export class MissAnim1 extends MissAnimBase {
    //-------------------------------------------------------------------------
    /**
     * 
     * @param ballPos Pozice, na ktere bude mic pri dosazeni Z pozice brankare
     * @param ballTime Cas, kdy mic dosahne pozice brankare
     * @param data 
     */
    //-------------------------------------------------------------------------
    init(ballPos: pc.Vec2, ballTime: number, data: GoalieMissAnim): void {
        let hDir = ballPos.x - this._goalie.entity.getPosition().x;

        if (data.animSwappedDir)
            hDir *= -1;

        this._flags = 0;
        this._animStartTime = ballTime - data.animTimeOffset;
        this._animName = data.animName + (hDir > 0 ? "L" : "R");
    }
}